<template>
  <div>
    <hsm-header></hsm-header>
    <container-nav>
      <template slot-scope="p">
        <Nav :list="p.list" :styles="p.styles" sticky></Nav>
      </template>
    </container-nav>
    <div class="admin_bg">
      <div class="wrap w1200" style="height: 50px; line-height: 50px; margin-top: 0;">
        首页 - 管理企业 - {{currentPath}}
      </div>
      <div class="wrap w1200" style="position:relative">
        <div class="left_menu_icon" @click="switchMenu($event)"></div>
        <div class="col_1 w222 left_con" v-if="menuStatus">
          <Accordion :model="rmenus" @route-changed="routeChanged"></Accordion>
        </div>
        <div class="w978 w_bg col_2" id="org_right_container">
          <div class="loadingtxt">
            <router-view></router-view>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <hsm-footer></hsm-footer>
  </div>
</template>
<script>
  import hsmHeader from '@/pages/others/header'
  import hsmFooter from '@/pages/others/footer'
  import containerNav from '@/containers/nav/containerNav'
  import Nav from '@/components/hsm/nav/index'
  import utils from '@/utils'
  import { getCookie } from '@/store/cookies.js'
  import containerMenuList from '@/containers/menu/containerGetMenusByRole'
  import expireService from '@/utils/expired'
  import Accordion from '@/components/common/accordion/index.vue'
  import Bus from '@/utils/bus'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    components: { hsmHeader, hsmFooter, containerNav, Nav, Accordion, containerMenuList },
    data () {
      return {
        currentPath: this.$route.name,
        fuser: {},
        rmenus: [],
        menuStatus: true
      }
    },
    created () {
    },
    mounted () {
      this.getMenus({isShow: '1'}) // 取左侧菜单
    },
    watch: {
      $route (val) {
        if (val.query.refresh) {
          this.$router.push(this.rmenus[0].href) // 默认跳转第一个菜单
        }
      },
      user (val) {
        if (val) {
          this.fuser = val
        }
      },
      getCurrentMenus (val) { // 确保已获取到菜单的数据
        function iteration (data, level) {
          level++
          for (var j = 0; j < data.length; j++) {
            data[j].level = level
            data[j].redirectTo = data[j].href
            if (data[j].children != undefined && data[j].children.length > 0) {
              iteration(data[j].children, level)
            }
          }
        }
        iteration(val, 0)
        this.rmenus = val
        if (this.rmenus) {
          this.$router.push(this.rmenus[0].href) // 默认跳转第一个菜单
        }
        this.rmenus.forEach((o) => {
          if (o.href == this.$route.path) {
            o.active = true // 当前菜单点亮
            if (o.children) {
              o.opened = true
              // iteration(o.children) // 子孙也要点亮
            }
          } else {
            o.active = false
          }
        })
      }
    },
    computed: {
      ...mapState('auth', ['user', 'token']),
      ...mapState('orgmenus', ['menus']),
      ...mapGetters('orgmenus', ['getCurrentMenus'])
    },
    methods: {
      ...mapActions('auth', {
        logout: 'logout'
      }),
      ...mapActions('orgmenus', {
        getMenus: 'getMenus'
      }),
      toLogout () {
        this.logout()
      },
      routeChanged (route) {
        this.currentPath = route.name
        Bus.$emit('initData_' + route.href) // 为了刷新子路由里的数据
      },
      switchMenu ($event) {
        this.menuStatus = !this.menuStatus;
        this.menuStatus === true ? this.getMenus({isShow: '1'}) : '';
        if ($($event.target).hasClass("left_menu_icon")) {
          $($event.target).removeClass("left_menu_icon").addClass("right_menu_icon");
          $("#org_right_container").removeClass("w978").addClass("w1200");
          $(".zy_right").removeClass("w797").addClass("w1004");
          $(".structure_org_stretch").removeClass("w705").addClass("w925");
          $(".withInputs_stretch").removeClass("w365").addClass("w585");
          $("#org_right_container").css("box-shadow", "-6px 0px 15px #e6e6e6")
        } else if ($($event.target).hasClass("right_menu_icon")) {
          $($event.target).removeClass("right_menu_icon").addClass("left_menu_icon");
          $("#org_right_container").removeClass("w1200").addClass("w978");
          $(".zy_right").removeClass("w1004").addClass("w797");
          $(".structure_org_stretch").removeClass("w925").addClass("w705");
          $(".withInputs_stretch").removeClass("w585").addClass("w365");
        }
      }
    }
  }
</script>
<style lang="scss">
  @import "./assets/admin";
</style>



// WEBPACK FOOTER //
// src/pages/admin/pageIndex.vue